import React, { ChangeEvent, useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import { UdsFC } from '../../../types';
import { Switch, SwitchProps } from '../../Switch/Switch';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormSwitch: UdsFC<SwitchProps> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'checked' in props ? props.checked : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, !value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue, value]
  );
  return (
    <Switch
      {...props}
      style={{ marginTop: 22 }}
      checked={value}
      onChange={handleOnChange}
      data-test={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};
